// Module
var code = "<div class=\"product-differences-toggle\"> <input type=\"checkbox\" class=\"product-differences-toggle__checkbox\" id=\"differences-toggle\" ng-change=\"$ctrl.onChange()\" ng-model=\"$ctrl.isToggleOn\"> <label for=\"differences-toggle\" system-dictionary=\"HighlightDifferences\"></label> </div>";
// Exports
module.exports = code;